module.exports = __webpack_public_path__ + "img/window-plugin-success.47183359.png";